import { render, staticRenderFns } from "./FormColumnRuler.vue?vue&type=template&id=629b0d6c&scoped=true"
import script from "./FormColumnRuler.vue?vue&type=script&lang=js"
export * from "./FormColumnRuler.vue?vue&type=script&lang=js"
import style0 from "./FormColumnRuler.vue?vue&type=style&index=0&id=629b0d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629b0d6c",
  null
  
)

export default component.exports